import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=12308ac6&scoped=true&"
import script from "./patient.vue?vue&type=script&lang=js&"
export * from "./patient.vue?vue&type=script&lang=js&"
import style0 from "./patient.vue?vue&type=style&index=0&id=12308ac6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12308ac6",
  null
  
)

export default component.exports